import React from 'react';
import PropTypes from 'prop-types';
import { FILTERS } from '../../constants';

// TaskFilterコンポーネント
const TaskFilter = ({ selectedFilter, onFilterChange, className = '' }) => {
  return (
    <div className={`mb-4 ${className}`}>
      <label htmlFor="task-filter" className="block text-sm font-medium text-purple-700 mb-2">
        表示フィルター
      </label>
      <select
        id="task-filter"
        value={selectedFilter.id}
        onChange={(e) => {
          const filter = FILTERS.find((f) => f.id === e.target.value);
          onFilterChange(filter);
        }}
        className="w-full p-2 border border-purple-300 rounded focus:outline-none focus:ring-2 focus:ring-purple-300"
        aria-label="課題フィルター選択"
      >
        {FILTERS.map((filter) => (
          <option key={filter.id} value={filter.id}>
            {filter.name}
          </option>
        ))}
      </select>
    </div>
  );
};

TaskFilter.propTypes = {
  selectedFilter: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TaskFilter; 